module.exports = {
    topHead: {
        select_option_category: "类目",
        select_option_category_holder: "请选择类目",
        select_option_brand: "品牌",
        select_option_brand_holder: "请选择",
        select_option_postKeyWords: "帖子关键词",
        select_option_postKeyWords_holder: "请输入内容",
        rules_message_search: "品牌和帖子内容至少输入一个",
        my_attention: "我的关注",
        login_label: "登录",
        login_out: "退出",
        Chinese: "中文",
        English: "English",
    },
    inspiration: {
        amazon: "亚马逊",
        amazon_us: "亚马逊美国站",
        amazon_de: "亚马逊德国站",
        amazon_es: "亚马逊西班牙",
        amazon_fr: "亚马逊法国站",
        amazon_it: "亚马逊意大利站",
        amazon_uk: "亚马逊英国站",
        amazon_jp: "亚马逊日本站",
        shopee: "虾皮",
        shopee_vn: "虾皮越南站",
        shopee_th: "虾皮泰国站",
        shopee_sg: "虾皮新加坡站",
        shopee_my: "虾皮马来西亚站",
        shopee_ph: "虾皮菲律宾站",
        shopee_id: "虾皮印尼站",
        shopee_tw: "虾皮中国台湾站",
        lazada: "来赞达",
        lazada_vn: "来赞达越南站",
        lazada_th: "来赞达泰国站",
        lazada_sg: "来赞达新加坡站",
        lazada_my: "来赞达马来西亚站",
        lazada_ph: "来赞达菲律宾站",
        lazada_id: "来赞达印尼站",
    },
    inspTh: {
        analyze_name: "名称",
        product_name: "产品",
        plat: "平台/类目",
        publish_user: "作者",
        publish_time: "发布时间",
        share_count: "添加次数",
        operation: "操作",
    },
};